import { liveCallTasksAction } from "../actions/livecallTasksAction";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shouldCountLiveCallTodoTasks: false,
};

const liveCallTasksSlice = createSlice({
  name: "liveCallTasks",
  initialState: initialState,
  reducers: liveCallTasksAction,
});

export const { countLiveCallTodoTasks } = liveCallTasksSlice.actions;

export default liveCallTasksSlice.reducer;
